export function formatCurrency(value, options = {}) {
  const { compact = false, decimals = 0 } = options

  if (value === null || value === undefined) return '-'

  if (compact && Math.abs(value) >= 1000000) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      notation: 'compact',
      maximumFractionDigits: 1
    }).format(value)
  }

  if (compact && Math.abs(value) >= 1000) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      notation: 'compact',
      maximumFractionDigits: 1
    }).format(value)
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(value)
}

export function formatNumber(value, options = {}) {
  const { compact = false, decimals = 0 } = options

  if (value === null || value === undefined) return '-'

  if (compact) {
    return new Intl.NumberFormat('en-US', {
      notation: 'compact',
      maximumFractionDigits: 1
    }).format(value)
  }

  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(value)
}

export function formatPercent(value, options = {}) {
  const { decimals = 1, showSign = false } = options

  if (value === null || value === undefined) return '-'

  const formatted = new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(value)

  if (showSign && value > 0) {
    return '+' + formatted
  }

  return formatted
}

export function formatMonth(monthStr) {
  if (!monthStr) return '-'

  const [year, month] = monthStr.split('-')
  const date = new Date(year, month - 1)

  return date.toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric'
  })
}

export function formatDate(dateStr) {
  if (!dateStr) return '-'

  const date = new Date(dateStr)

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  })
}

export function formatMonthShort(monthStr) {
  if (!monthStr) return '-'

  const [year, month] = monthStr.split('-')
  const date = new Date(year, month - 1)

  return date.toLocaleDateString('en-US', {
    month: 'short',
    year: '2-digit'
  })
}

export function getMonthsInRange(startMonth, endMonth, allMonths) {
  if (!startMonth || !endMonth) return allMonths

  return allMonths.filter(m => m >= startMonth && m <= endMonth)
}

export function calculateGrowth(current, previous) {
  if (!previous || previous === 0) return null
  return (current - previous) / previous
}

export function getCountryName(code) {
  const countries = {
    'US': 'United States',
    'UK': 'United Kingdom',
    'NL': 'Netherlands',
    'DE': 'Germany',
    'CA': 'Canada',
    'AU': 'Australia'
  }
  return countries[code] || code
}
